
import { useState, useEffect } from 'react';
import Email from './Components/Email';
import Phone from './Components/Phone';
import Content from './Components/Content';

import { protectEvent, clickOpenMailTo, clickOpenTelTo, clickOpenTab, checkContent, openTool, closeTool, reverseString } from './utils/functions';
import Url from './Components/Url';


const ProtectContent = ({ attributes, clientId }) => {

    const { content, contentType, contentTypo } = attributes;
    const [enCode, setenCode] = useState('');
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    const enCodeContent = (content) => {
        return window.btoa(content);
    }

    useEffect(() => {
        checkContent(contentType, setenCode, enCodeContent, content);
    }, [enCodeContent]);


    useEffect(() => {
        protectEvent(clientId);
        const words = document.querySelector(`#container-${clientId}.eebTextInitial span`)?.textContent?.split(' ') || document.querySelector(`#container-${clientId}.eebTextInitial a`)?.textContent?.split(' ');

        setTimeout(() => {
            if (words) {
                const capitalizedWords = words.map(word => {
                    const lastChar = word.slice(-1).toUpperCase();
                    const firstChar = word[0].toLowerCase();
                    const restOfWord = word.slice(1, -1);
                    return firstChar + restOfWord + lastChar;
                });

                let selectorTag = 'a';
                if (contentType === "text") {
                    selectorTag = 'span';
                }
                document.querySelector(`#container-${clientId}.eebTextInitial ${selectorTag}`).innerHTML = capitalizedWords.join(' ');
            }
        }, 10);

    }, [contentTypo?.textTransform]);

    useEffect(() => {
        window.addEventListener('resize', () => {
            if (window.innerWidth < windowSize.width || window.innerHeight < windowSize.height) {
                openTool(clientId, contentType, content);

            } else {
                closeTool(clientId, setWindowSize, contentType, content);
            }
        });
    }, [clientId, windowSize, contentType]);


    return <div className={`${contentTypo.textTransform === 'capitalize' ? 'eebTextInitial' : ''} eeb_protected_area content-${clientId}`} id={`container-${clientId}`}>
        {(() => {
            switch (contentType) {
                case "text":
                    return <Content attributes={attributes} reverseString={reverseString} />;
                case "phone":
                    return <Phone enCode={enCode} attributes={attributes} clickOpenTelTo={clickOpenTelTo} reverseString={reverseString} />;
                case "email":
                    return <Email enCode={enCode} attributes={attributes} clickOpenMailTo={clickOpenMailTo} reverseString={reverseString} />;
                case "url":
                    return <Url clickOpenTab={clickOpenTab} enCode={enCode} attributes={attributes} reverseString={reverseString} />;
                default:
                    return null;
            }
        })()}

    </div>

}
export default ProtectContent;